import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '.../../../src/app/modules/shared/services/geral/app.service';
import { FilterUtils } from '../../../shared/utils/filterutils';

@Component({
  selector: 'app-cliente-sem-autorizador',
  templateUrl: './cliente-sem-autorizador.component.html',
  styleUrls: ['./cliente-sem-autorizador.component.css']
})
export class ClienteSemAutorizadorComponent implements OnInit {

  constructor(public svc: AppService, private router: Router, private tl: TranslateService) { 
        //Carrega as Traduções Gerais da Tela
      this.svc.sbGetTraducaoAuto("geral.mensagens").subscribe((resp) => {
        this.traducao.geral = resp;
      });
  
      this.svc.sbGetTraducaoAuto("cadastro_poderes_tabela").subscribe((resp) => {
        this.traducao.tabela = resp;
      });
  }

  public tipo_manutencao: string;
  public cols: any[];
  public clientes: any[];
  public novo_cliente: any = {
    ind_assina_contrato: "",
    cnpj: "",
    razao_social: ""
  };
  public traducao: any = {
    geral: "",
    tabela: ""
  }
  public spinTable = false;
  public spinClienteCRUD = false;

  public sbRetornarFiltros(lista: any[], column: string): any {
    var retorno = [];

    if (lista) {
      for (let i = 0; i < lista.length; i++) {
        retorno.push(lista[i][column]);
      }

      retorno = retorno.filter(function (value, index) { return retorno.indexOf(value) == index });

      for (let i = 0; i < retorno.length; i++) {
        retorno[i] = { label: retorno[i], value: retorno[i] }
      }
    }

    return retorno;
  }

  public sbCarregarIdioma(dados) {
    this.cols = [
      { type: 'text-duplo', filter: true, filter_type: 'multi-select', header: dados.cliente, field: 'nome_cliente', size: '80%', coluna_aux: 'documento_cliente' },
      { type: 'hide', filter: false, filter_type: 'multi-select', header: '', field: 'documento_cliente', size: '0%' },
      { type: 'text', filter: true, filter_type: 'multi-select', header: dados.assinatura, field: 'ind_assinatura', size: '20%' },
    ];
  }

  public sbRedirecionar(data) {
    try {
      this.router.navigate(['/cadastro-poderes-cliente', JSON.stringify(data)], { skipLocationChange: true });
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

  public carregarClientes(){
    try{
       //Carrega os Dados da Tabela Tipos de Processo
       this.spinTable = true;
       this.svc.CadastroPoderesSemPesquisar();
       this.svc.CadastroPoderesSem().subscribe((resp) => {
         if (resp == false) this.spinTable = false;
         else if (resp != null) {
           this.spinTable = false;
           this.clientes = resp.clientes;
         }
       });
    } catch(e){
      throw e;
    }
  }

  ngOnInit() {
    try {
      this.sbCarregarIdioma(this.traducao.tabela);
      this.carregarClientes();

      //É chamado sempre que o Idioma for Mudado
      this.svc.sbGetTraducaoAuto("cadastro_poderes_tabela").subscribe((resp) => {
        this.sbCarregarIdioma(resp);
      });

      FilterUtils['custom'] = (value, filter): boolean => {
        if (filter === undefined || filter === null || filter.trim() === '') {
          return true;
        }

        if (value === undefined || value === null) {
          return false;
        }

        return parseInt(filter) > value;
      };

    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }

}
